import { render, staticRenderFns } from "./modalPedidoMinimo.vue?vue&type=template&id=09984429"
import script from "./modalPedidoMinimo.vue?vue&type=script&lang=js"
export * from "./modalPedidoMinimo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports